import {
  FormFieldsType,
  TimeLapsedOptionType,
} from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

abstract class DependentField extends FormFieldWithInitialValue {
  isDependent = false;
  dependentField: Array<string>;
  dependentOnField: string;
  optionsType?: string;
  timeLapsedOptions?: Array<TimeLapsedOptionType>;
  showOnlySlotTime?: boolean;

  constructor(dependentFieldsData: FormFieldsType, initialValue: any) {
    super(dependentFieldsData, initialValue);
    this.dependentField = dependentFieldsData.dependent_fields ?? [];
    this.dependentOnField = dependentFieldsData.dependent_on_field ?? '';
    this.optionsType = dependentFieldsData.options_type;
    this.timeLapsedOptions = dependentFieldsData.time_lapsed_options;
    this.showOnlySlotTime = dependentFieldsData.show_only_slot_time;
    if (
      dependentFieldsData.dependent_on_field ||
      dependentFieldsData.dependent_fields
    ) {
      this.isDependent = true;
    }
  }
}

export default DependentField;
